import { SubscriptionDashboard } from '../components/LearnEarn/SubscriptionDashboard';

function SubscriptionDashboardPage() {
  console.log('📄 SubscriptionDashboardPage component loaded');
  return <SubscriptionDashboard />;
}

export default SubscriptionDashboardPage;